/* unplugin-vue-components disabled */import { render } from "./file-skeleton.vue?vue&type=template&id=e461dfc6&scoped=true"
const script = {}

import "./file-skeleton.vue?vue&type=style&index=0&id=e461dfc6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e461dfc6"],['__file',"src/components/ai-chat-v2/ai-file/file-skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e461dfc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e461dfc6', __exports__)) {
    api.reload('e461dfc6', __exports__)
  }
  
  module.hot.accept("./file-skeleton.vue?vue&type=template&id=e461dfc6&scoped=true", () => {
    api.rerender('e461dfc6', render)
  })

}


export default __exports__